/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActiveSeasonRow } from './ActiveSeasonRow';
import {
    ActiveSeasonRowFromJSON,
    ActiveSeasonRowFromJSONTyped,
    ActiveSeasonRowToJSON,
    ActiveSeasonRowToJSONTyped,
} from './ActiveSeasonRow';

/**
 * 
 * @export
 * @interface ActiveSeasonsWidgetData
 */
export interface ActiveSeasonsWidgetData {
    /**
     * 
     * @type {Array<ActiveSeasonRow>}
     * @memberof ActiveSeasonsWidgetData
     */
    items: Array<ActiveSeasonRow>;
}

/**
 * Check if a given object implements the ActiveSeasonsWidgetData interface.
 */
export function instanceOfActiveSeasonsWidgetData(value: object): value is ActiveSeasonsWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ActiveSeasonsWidgetDataFromJSON(json: any): ActiveSeasonsWidgetData {
    return ActiveSeasonsWidgetDataFromJSONTyped(json, false);
}

export function ActiveSeasonsWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveSeasonsWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ActiveSeasonRowFromJSON)),
    };
}

export function ActiveSeasonsWidgetDataToJSON(json: any): ActiveSeasonsWidgetData {
    return ActiveSeasonsWidgetDataToJSONTyped(json, false);
}

export function ActiveSeasonsWidgetDataToJSONTyped(value?: ActiveSeasonsWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ActiveSeasonRowToJSON)),
    };
}

